import { render, staticRenderFns } from "./block-educator.vue?vue&type=template&id=6a8b048c&scoped=true&"
import script from "./block-educator.vue?vue&type=script&lang=js&"
export * from "./block-educator.vue?vue&type=script&lang=js&"
import style0 from "./block-educator.vue?vue&type=style&index=0&id=6a8b048c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8b048c",
  null
  
)

export default component.exports